import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { AumicoCoreConfig, AumicoCoreConfigService } from './../aumico-core.config';
import { getCaptionString, LocalizedCaption } from '../utils/caption-utils';

/**
 * Resolves a value that may still be stored as a locale-keyed object (e.g. an FLI caption that
 * didn't migrate to a plain string) to its display string. Prefers the passed `languageKey` (the
 * report language), then the app's current language, then the first available locale — so it never
 * renders "[object Object]". A plain-string value passes through unchanged.
 */
@Pipe({
    name: 'valueFor',
    pure: false,
})
export class ValueForLanguagePipe implements PipeTransform {
    @Optional()
    @Inject(AumicoCoreConfigService)
    private config?: AumicoCoreConfig;
    constructor() {}
    transform(content: LocalizedCaption, languageKey?: string): string {
        return getCaptionString(content, languageKey, this.config && this.config.currentLanguageKey);
    }
}
